//* Libraries imports
import { api } from "../api";

//* Types imports
import type { ApiResponse, ApiError } from "@/types/api";
import type {
  CreateCustomerAsaasDTO,
  CustomerResponseAsaasDTO,
} from "@/schemas/asaas/customer";

class CustomerAsaasService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${api.API_URL}/asaas/customers`;
  }

  async create(
    data: CreateCustomerAsaasDTO,
  ): Promise<ApiResponse<CustomerResponseAsaasDTO> | ApiError> {
    return await api.request<CustomerResponseAsaasDTO>(this.baseUrl, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }
}

export const customerAsaasService = new CustomerAsaasService();
